module.exports = __webpack_public_path__ + "img/merch-dark.5d4ca314.jpg";